const noData = [null, "", undefined, "null"]

const state = {
  data: {
    oneTimeInvoicesTableData: null,
    recurringInvoicesTableData: null,
    residentialSubscriptionsTableData: null,
    commercialSubscriptionsTableData: null,
    changeRequestsTableData: null,
    commercialClientsTableData: null,
    resClientBillingTableData: null,
    comClientBillingTableData: null,
    resMessagesNotesTableData: null,
    comMessagesNotesTableData: null,
    resClientScheduleTableData: null,
    comClientScheduleTableData: null,
    residentialClientsTableData: null,
    resClientsNoSubTableData: null,
    pastOneTimeClientsTableData: null,
    dogInfoTableData: null,
    cleanupNotificationsReportTableData: null,
    openBalanaceReportTableData: null,
    dispatchBoardTableData: null,
    shiftsTableData: null,
    receiveCheckPaymentTableData: null,
    receiveCommercialCheckPaymentTableData: null,
    clientPaymentsLoading: null,
    editInvoiceTableData: null,
    clientInvoicesLoading: null,
    clientSubscriptionsLoading: null,
    clientBankAccountsLoading: null,
    clientCreditCardsLoading: null,
    clientInfoLoading: null,
    clientLocationLoading: null,
    royaltyPaymentsTableData: null,
    workAreaActivityLogTableData: null,
    inventoryTableData: null,
    inventoryPerWorkAreaTableData: null,
    inventoryPerClientTableData: null,
    staffTableData: null
  }
}

const getters = {
  getTableData: (state, getters) => name => {
    let value = state.data[name]
    if (
      !noData.includes(value) &&
      !noData.includes(value.data) &&
      !noData.includes(value.organization_id) &&
      !noData.includes(value.user_id) &&
      value.organization_id === getters.organizationId &&
      value.user_id === getters.userId
    ) {
      return value.data
    }
    return null
  },
  oneTimeInvoicesTableData: (state, getters) => getters.getTableData('oneTimeInvoicesTableData'),
  recurringInvoicesTableData: (state, getters) => getters.getTableData('recurringInvoicesTableData'),
  residentialSubscriptionsTableData: (state, getters) => getters.getTableData('residentialSubscriptionsTableData'),
  commercialSubscriptionsTableData: (state, getters) => getters.getTableData('commercialSubscriptionsTableData'),
  changeRequestsTableData: (state, getters) => getters.getTableData('changeRequestsTableData'),
  commercialClientsTableData: (state, getters) => getters.getTableData('commercialClientsTableData'),
  resClientBillingTableData: (state, getters) => getters.getTableData('resClientBillingTableData'),
  comClientBillingTableData: (state, getters) => getters.getTableData('comClientBillingTableData'),
  resMessagesNotesTableData: (state, getters) => getters.getTableData('resMessagesNotesTableData'),
  comMessagesNotesTableData: (state, getters) => getters.getTableData('comMessagesNotesTableData'),
  resClientScheduleTableData: (state, getters) => getters.getTableData('resClientScheduleTableData'),
  comClientScheduleTableData: (state, getters) => getters.getTableData('comClientScheduleTableData'),
  residentialClientsTableData: (state, getters) => getters.getTableData('residentialClientsTableData'),
  resClientsNoSubTableData: (state, getters) => getters.getTableData('resClientsNoSubTableData'),
  pastOneTimeClientsTableData: (state, getters) => getters.getTableData('pastOneTimeClientsTableData'),
  dogInfoTableData: (state, getters) => getters.getTableData('dogInfoTableData'),
  cleanupNotificationsReportTableData: (state, getters) => getters.getTableData('cleanupNotificationsReportTableData'),
  openBalanaceReportTableData: (state, getters) => getters.getTableData('openBalanaceReportTableData'),
  dispatchBoardTableData: (state, getters) => getters.getTableData('dispatchBoardTableData'),
  shiftsTableData: (state, getters) => getters.getTableData('shiftsTableData'),
  receiveCheckPaymentTableData: (state, getters) => getters.getTableData('receiveCheckPaymentTableData'),
  receiveCommercialCheckPaymentTableData: (state, getters) => getters.getTableData('receiveCommercialCheckPaymentTableData'),
  clientPaymentsLoading: (state, getters) => getters.getTableData('clientPaymentsLoading'),
  editInvoiceTableData: (state, getters) => getters.getTableData('editInvoiceTableData'),
  clientInvoicesLoading: (state, getters) => getters.getTableData('clientInvoicesLoading'),
  clientSubscriptionsLoading: (state, getters) => getters.getTableData('clientSubscriptionsLoading'),
  clientBankAccountsLoading: (state, getters) => getters.getTableData('clientBankAccountsLoading'),
  clientCreditCardsLoading: (state, getters) => getters.getTableData('clientCreditCardsLoading'),
  clientInfoLoading: (state, getters) => getters.getTableData('clientInfoLoading'),
  clientLocationLoading: (state, getters) => getters.getTableData('clientLocationLoading'),
  royaltyPaymentsTableData: (state, getters) => getters.getTableData('royaltyPaymentsTableData'),
  workAreaActivityLogTableData: (state, getters) => getters.getTableData('workAreaActivityLogTableData'),
  inventoryTableData: (state, getters) => getters.getTableData('inventoryTableData'),
  inventoryPerWorkAreaTableData: (state, getters) => getters.getTableData('inventoryPerWorkAreaTableData'),
  inventoryPerClientTableData: (state, getters) => getters.getTableData('inventoryPerClientTableData'),
  staffTableData: (state, getters) => getters.getTableData('staffTableData'),

  clientDetailsLoading(state, getters) {
    return getters.clientInfoLoading || 
      getters.clientLocationLoading || 
      getters.clientSubscriptionsLoading || 
      getters.clientPaymentsLoading || 
      getters.clientInvoicesLoading ||
      getters.clientCreditCardsLoading ||
      getters.clientBankAccountsLoading
  }
}

const actions = {
  setTableData (context, data) {
    if (
      !noData.includes(data.key)
    ) {
      let value = {
        organization_id: context.getters.organizationId,
        user_id: context.getters.userId,
        data: null
      }
      value.data = data.value
      context.commit('setTableData', {
        key: data.key,
        value
      })
    }
  }
}

const mutations = {
  setTableData (state, data) {
    state.data[data.key] = data.value
  }
}

export default {
  state,
  actions,
  mutations,
  getters
};